module.exports = __webpack_public_path__ + "static/media/ic_QR_scan.80fd79a3.svg";